import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {
    FormBuilder,

    FormControl,

    FormGroup,
    Validators
} from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { BuildYourAppSummary } from '~/models/administration/buildYourApp';
import { BuildYourAppsService } from '~/services/modules/stocks/administration/build-your-apps';
import { MobileAppGroupsService } from '~/services/modules/stocks/administration/mobile-app-groups';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { mobileDevices } from './mobile-devices';
@Component({
    selector: 'app-build-your-apps-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss', './android.scss', './ios.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class BuildYourAppsUpsertComponent implements OnInit, OnDestroy {
    _kendoTabStripPosition = 'left';
    _innerWidth: any;
    _hiddenWindow: any;
    _maximized: any;
    _theme: string;
    _isNew: boolean;
    _form: FormGroup;
    _active: boolean;
    _isAutoGeneratingNumber: boolean;
    _tabEnabled: boolean;
    _currentType: string;
    _invalidForm: boolean;
    _buttonPreviewClicked: boolean;
    _model: BuildYourAppSummary;
    selectedFields: any = [];
    fields: any = [];
    selectedFields_receive: any = null;
    fields_receive: any = null;
    selectedFields_move: any = null;
    fields_move: any = null;
    selectedFields_physicalInventory: any = null;
    fields_physicalInventory: any = null;
    selectedFields_dispose: any = null;
    fields_dispose: any = null;
    selectedFields_issue: any = null;
    fields_issue: any = null;
    selectedFields_pack: any = null;
    fields_pack: any = null;
    selectedFields_ship: any = null;
    fields_ship: any = null;
    selectedFields_return: any = null;
    fields_return: any = null;
    _mobileDeviceSelected = new FormControl();
    _mobileDeviceTypeSelected = new FormControl();
    _mobileDevices = mobileDevices;
    _mobileDeviceTypes: any[];
    _mobileImageSrc = 'iphone-12.png';
    _mobileImageClass = 'iphone-12';
    _mobileAppGroups: any[];
    _mobileAppGroupsFiltered: any[];
    _transactions: any[];
    _transactionsFiltered: any[];
    _selectedTransactionId: any;

    @ViewChild('kendo_combo_Groupe_name') kendoComboGroupName: ComboBoxComponent;
    @ViewChild('kendo_tabstrip_wrapper') navTrigger: ElementRef;
    @ViewChild('transactions_combo') kendoComboTransactions: ComboBoxComponent;

    constructor(
        private _buildYourAppsService: BuildYourAppsService,
        private _mobileAppGroupsService: MobileAppGroupsService,
        private _fb: FormBuilder,
        private _themeManager: ThemeManagerService,
        private _layoutManager: LayoutManagerService,
        private _layoutComponent: LayoutComponent,
        private _gridLayoutManagerService: GridLayoutManagerService,
        private _gridFields: GridFieldsService,
        @Inject(PORTAL_DATA) public data: any
    ) {
        if (data) {
            this._model = data.model;
            this._isNew = data.isNew;
            this._active = true;
        }
        this._themeManager.themeChange.subscribe((data) => {
            this._theme = data;
        });
        this._layoutManager.applyOverly();

        this._mobileDeviceSelected.valueChanges.subscribe((x) => {
            this._mobileDeviceTypes = this._mobileDevices
                .find(y => y.key === this._mobileDeviceSelected.value)['types'];

            this._mobileDeviceTypeSelected.setValue(this._mobileDeviceTypes[0].key);
        });

        this._mobileDeviceSelected.setValue('ios');
    }

    ngOnInit() {
        this._initForm();
        this._LoadMobileAppGroupsDD();
        this._loadGroupeNAmeDD();
        this._form.get('mobileAppGroup').valueChanges.subscribe((x) => {
            if (x) {
                setTimeout(() => {
                    this.kendoComboTransactions.toggle(true);
                    this.kendoComboTransactions.focus();
                });
            }
        });
    }
    _loadGroupeNAmeDD() {
        setTimeout(() => {
            this.kendoComboGroupName.toggle(true);
            this.kendoComboGroupName.focus();
        });
    }
    _LoadMobileAppGroupsDD() {
        return this._mobileAppGroupsService.getMobileAppGroupListing()
            .subscribe((data: any) => {
                this._mobileAppGroups = data;
                this._mobileAppGroupsFiltered = this._mobileAppGroups;
            });
    }

    _handleMobileAppGroupsFilter(value: any) {
        this._mobileAppGroupsFiltered = this._mobileAppGroups.filter(
            (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _loadTransactionsDD(mobileAppGroup: any) {
        if (!this._model) {
            this.resetTransactionFieldsVariables();
            this.kendoComboTransactions.reset();
            this._transactions = this._transactionsFiltered = [];
            this.fields = this.selectedFields = [];
        }
        if (mobileAppGroup != undefined) {
            var mobileAppGroupId = mobileAppGroup?.id;
            return this._buildYourAppsService.getTransactionListingByMobileAppGroupId(mobileAppGroupId)
                .subscribe((data: any) => {
                    this._transactions = this._transactionsFiltered = data;
                });
        }
    }

    _handleTransactionsFilter(value: any) {
        this._transactionsFiltered = this._transactions.filter(
            (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
        );
    }

    _loadFields(transaction: any) {
        this.fields = this.selectedFields = [];
        if (transaction != undefined) {
            var transactionId = transaction?.id;
            switch (transactionId) //todo asset transactions
            {
                case 9:
                    if (this.selectedFields_receive != null && this.fields_receive != null) {
                        this.selectedFields = this.selectedFields_receive;
                        this.fields = this.fields_receive;
                        return;
                    }
                    break;
                case 5:
                    if (this.selectedFields_move != null && this.fields_move != null) {
                        this.selectedFields = this.selectedFields_move;
                        this.fields = this.fields_move;
                        return;
                    }
                    break;
                case 8:
                    if (this.selectedFields_physicalInventory != null && this.fields_physicalInventory != null) {
                        this.selectedFields = this.selectedFields_physicalInventory;
                        this.fields = this.fields_physicalInventory;
                        return;
                    }
                    break;
                case 3:
                    if (this.selectedFields_dispose != null && this.fields_dispose != null) {
                        this.selectedFields = this.selectedFields_dispose;
                        this.fields = this.fields_dispose;
                        return;
                    }
                    break;
                case 4:
                    if (this.selectedFields_issue != null && this.fields_issue != null) {
                        this.selectedFields = this.selectedFields_issue;
                        this.fields = this.fields_issue;
                        return;
                    }
                    break;
                case 6:
                    if (this.selectedFields_pack != null && this.fields_pack != null) {
                        this.selectedFields = this.selectedFields_pack;
                        this.fields = this.fields_pack;
                        return;
                    }
                    break;
                case 13:
                    if (this.selectedFields_ship != null && this.fields_ship != null) {
                        this.selectedFields = this.selectedFields_ship;
                        this.fields = this.fields_ship;
                        return;
                    }
                    break;
                case 11:
                    if (this.selectedFields_return != null && this.fields_return != null) {
                        this.selectedFields = this.selectedFields_return;
                        this.fields = this.fields_return;
                        return;
                    }
                    break;
                default:
                    break;
            }

            return this._buildYourAppsService.getFieldsListingByTransactionId(transactionId)
                .subscribe((data: any) => {
                    var availableFields: { isSelected: boolean; title: any; }[] = [];
                    data.availableFields.split(',').forEach((item: any) => {
                        availableFields.push({ isSelected: false, title: item });
                    });
                    this.fields = availableFields;
                    var selectedFields: { isSelected: boolean; title: any; }[] = [];
                    data.selectedFields.split(',').forEach((item: any) => {
                        selectedFields.push({ isSelected: true, title: item });
                    });
                    this.selectedFields = selectedFields;

                    switch (transactionId) //todo asset transactions
                    {
                        case 9:
                            this.selectedFields_receive = this.selectedFields;
                            this.fields_receive = this.fields;
                            break;
                        case 5:
                            this.selectedFields_move = this.selectedFields;
                            this.fields_move = this.fields;
                            break;
                        case 8:
                            this.selectedFields_physicalInventory = this.selectedFields;
                            this.fields_physicalInventory = this.fields;
                            break;
                        case 3:
                            this.selectedFields_dispose = this.selectedFields;
                            this.fields_dispose = this.fields;
                            break;
                        case 4:
                            this.selectedFields_issue = this.selectedFields;
                            this.fields_issue = this.fields;
                            break;
                        case 6:
                            this.selectedFields_pack = this.selectedFields;
                            this.fields_pack = this.fields;
                            break;
                        case 13:
                            this.selectedFields_ship = this.selectedFields;
                            this.fields_ship = this.fields;
                            break;
                        case 11:
                            this.selectedFields_return = this.selectedFields;
                            this.fields_return = this.fields;
                            break;
                        default:
                            break;
                    }
                });
        }
    }

    _onMobileImagePreview() {
        this.selectedFields = this.selectedFields.filter((i: any) => i.title != "");
        this._mobileImageSrc = this._mobileDevices
            .find(y => y.key === this._mobileDeviceSelected.value)['types']
            .find(y => y.key === this._mobileDeviceTypeSelected.value)['img'];

        this._mobileImageClass = this._mobileDeviceTypeSelected.value;
        this._buttonPreviewClicked = true;

    }

    _onStateChanges(e: any) {
        if (e === 'minimized') {
            this._layoutManager.removeOverlay();
        } else {
            this._layoutManager.applyOverly();
        }
    }

    ngOnDestroy() {
        this._layoutManager.removeOverlay();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this._innerWidth = window.innerWidth;
        if (this._innerWidth > 450) {
            this._hiddenWindow = 'hidden';
            this._maximized = 'maximized';
        } else {
            this._hiddenWindow = '';
            this._maximized = 'default';
        }
        let windowSize = window.innerWidth;

        if (windowSize <= 991) {
            this._kendoTabStripPosition = 'top';
        } else {
            this._kendoTabStripPosition = 'left';
        }
    }

    _onTabSelect(e: any) {
        this._mobileMenuToggle();
    }

    _mobileMenuToggle() {
        let mobiletabstrip = this.navTrigger.nativeElement.querySelector('ul');
        mobiletabstrip.classList.toggle('visibletab');
    }

    _onSave(e: any) {
        this.submit();
    }

    _onCancel() {
        this._closeForm();
    }

    _closeForm() {
        this._active = false;
        this._gridLayoutManagerService.setGridDataSubjects('buildYourApps');
        this.ngOnDestroy();
    }

    private _initForm() {
        this._form = this._fb.group({
            mobileAppGroup: [this._model ? { id: this._model.groupId, name: this._model.name } : null, Validators.required],
            transaction: [this._model ? this._model.transaction : null, Validators.required]
        });

        if (this._model) {
            if (this._model.groupId && this._model.name) {
                this._loadTransactionsDD({ id: this._model.groupId, name: this._model.name });
            }
            let that = this;
            if (this._model.receiveSelectedFields && this._model.receiveSelectedFields != "") {
                this.selectedFields_receive = [];
                this._model.receiveSelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_receive.push({ isSelected: true, title: item });
                });
            }
            if (this._model.moveSelectedFields && this._model.moveSelectedFields != "") {
                this.selectedFields_move = [];
                this._model.moveSelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_move.push({ isSelected: true, title: item });
                });
            }
            if (this._model.physicalInventorySelectedFields && this._model.physicalInventorySelectedFields != "") {
                this.selectedFields_physicalInventory = [];
                this._model.physicalInventorySelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_physicalInventory.push({ isSelected: true, title: item });
                });
            }
            if (this._model.disposeSelectedFields && this._model.disposeSelectedFields != "") {
                this.selectedFields_dispose = [];
                this._model.disposeSelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_dispose.push({ isSelected: true, title: item });
                });
            }
            if (this._model.issueSelectedFields && this._model.issueSelectedFields != "") {
                this.selectedFields_issue = [];
                this._model.issueSelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_issue.push({ isSelected: true, title: item });
                });
            }
            if (this._model.packSelectedFields && this._model.packSelectedFields != "") {
                this.selectedFields_pack = [];
                this._model.packSelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_pack.push({ isSelected: true, title: item });
                });
            }
            if (this._model.shipSelectedFields && this._model.shipSelectedFields != "") {
                this.selectedFields_ship = [];
                this._model.shipSelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_ship.push({ isSelected: true, title: item });
                });
            }
            if (this._model.returnSelectedFields && this._model.returnSelectedFields != "") {
                this.selectedFields_return = [];
                this._model.returnSelectedFields.split(',').forEach((item: any) => {
                    that.selectedFields_return.push({ isSelected: true, title: item });
                });
            }
            if (this._model.receiveAvailableFields && this._model.receiveAvailableFields != "") {
                this.fields_receive = [];
                this._model.receiveAvailableFields.split(',').forEach((item: any) => {
                    that.fields_receive.push({ isSelected: false, title: item });
                });
            }
            if (this._model.moveAvailableFields && this._model.moveAvailableFields != "") {
                this.fields_move = [];
                this._model.moveAvailableFields.split(',').forEach((item: any) => {
                    that.fields_move.push({ isSelected: false, title: item });
                });
            }
            if (this._model.physicalInventoryAvailableFields && this._model.physicalInventoryAvailableFields != "") {
                this.fields_physicalInventory = [];
                this._model.physicalInventoryAvailableFields.split(',').forEach((item: any) => {
                    that.fields_physicalInventory.push({ isSelected: false, title: item });
                });
            }
            if (this._model.disposeAvailableFields && this._model.disposeAvailableFields != "") {
                this.fields_dispose = [];
                this._model.disposeAvailableFields.split(',').forEach((item: any) => {
                    that.fields_dispose.push({ isSelected: false, title: item });
                });
            }
            if (this._model.issueAvailableFields && this._model.issueAvailableFields != "") {
                this.fields_issue = [];
                this._model.issueAvailableFields.split(',').forEach((item: any) => {
                    that.fields_issue.push({ isSelected: false, title: item });
                });
            }
            if (this._model.packAvailableFields && this._model.packAvailableFields != "") {
                this.fields_pack = [];
                this._model.packAvailableFields.split(',').forEach((item: any) => {
                    that.fields_pack.push({ isSelected: false, title: item });
                });
            }
            if (this._model.shipAvailableFields && this._model.shipAvailableFields != "") {
                this.fields_ship = [];
                this._model.shipAvailableFields.split(',').forEach((item: any) => {
                    that.fields_ship.push({ isSelected: false, title: item });
                });
            }
            if (this._model.returnAvailableFields && this._model.returnAvailableFields != "") {
                this.fields_return = [];
                this._model.returnAvailableFields.split(',').forEach((item: any) => {
                    that.fields_return.push({ isSelected: false, title: item });
                });
            }
        }
    }

    public toggleSelection(item: any, list: any) {
        if (item.isSelected != undefined)
            item.isSelected = !item.isSelected;
        else
            item.isSelected = true;
    }

    //#region  moveSelected
    public moveSelected(direction: any, from: any) {
        if (direction === 'left') {
            this.selectedFields.forEach((item: any) => {
                if (item.isSelected) {
                    this.fields.push(item);
                }
            });
            this.selectedFields = this.selectedFields.filter((i: any) => !i.isSelected);
        } else if (direction === 'right') {
            this.fields.forEach((item: any) => {
                if (item.isSelected) {
                    this.selectedFields.push(item);
                }
            });
            this.fields = this.fields.filter((i: any) => !i.isSelected);
        } else {
            var index = -1;
            var newIndex = -1;
            if (from === 'left') {
                index = this.fields.indexOf(this.fields.find((x: { isSelected: any; }) => x.isSelected));
                if (direction === 'up') {
                    newIndex = index - 1;
                }
                else if (direction === 'down') {
                    newIndex = index + 1;
                }
                this.fields = this.fields.filter((i: any) => i.title != "");
                if (newIndex > (this.fields.length - 1) || newIndex < 0) {
                    return;
                }
                this.fields.splice(newIndex, 0, this.fields.splice(index, 1)[0]);
            } else if (from === 'right') {
                index = this.selectedFields.indexOf(this.selectedFields.find((x: { isSelected: any; }) => x.isSelected));
                if (direction === 'up') {
                    newIndex = index - 1;
                }
                else if (direction === 'down') {
                    newIndex = index + 1;
                }
                this.selectedFields = this.selectedFields.filter((i: any) => i.title != "");
                if (newIndex > (this.selectedFields.length - 1) || newIndex < 0) {
                    return;
                }
                this.selectedFields.splice(newIndex, 0, this.selectedFields.splice(index, 1)[0]);
            }
        }
        this.adjustTransactionFieldsVariables();
        this._buttonPreviewClicked = false;
    }

    GetFieldsByCategory(category: any) {
        this._gridFields.getGridFieldsByPage(category.reportCategorycode).subscribe(
            (x) => {
                this.fields = x;
            }
        );
        this._gridFields.getGridFieldsByPage('users').subscribe(
            (x) => {
                this.fields = x;
            }
        );
    }
//#endregion

//#region  moveAll
    public moveAll(direction: any) {
        if (direction === 'left') {
            this.fields = [...this.fields, ...this.selectedFields];
            this.selectedFields = [];
        } else {
            this.selectedFields = [...this.selectedFields, ...this.fields];
            this.fields = [];
        }
        this.adjustTransactionFieldsVariables();
    }
//#endregion
    public adjustTransactionFieldsVariables() {
        switch (this._selectedTransactionId?.id) //todo asset transactions
        {
            case 9:
                this.selectedFields_receive = this.selectedFields;
                this.fields_receive = this.fields;
                break;
            case 5:
                this.selectedFields_move = this.selectedFields;
                this.fields_move = this.fields;
                break;
            case 8:
                this.selectedFields_physicalInventory = this.selectedFields;
                this.fields_physicalInventory = this.fields;
                break;
            case 3:
                this.selectedFields_dispose = this.selectedFields;
                this.fields_dispose = this.fields;
                break;
            case 4:
                this.selectedFields_issue = this.selectedFields;
                this.fields_issue = this.fields;
                break;
            case 6:
                this.selectedFields_pack = this.selectedFields;
                this.fields_pack = this.fields;
                break;
            case 13:
                this.selectedFields_ship = this.selectedFields;
                this.fields_ship = this.fields;
                break;
            case 11:
                this.selectedFields_return = this.selectedFields;
                this.fields_return = this.fields;
                break;
            default:
                break;
        }
    }

    public resetTransactionFieldsVariables() {
        this.selectedFields_receive = null;
        this.fields_receive = null;
        this.selectedFields_move = null;
        this.fields_move = null;
        this.selectedFields_physicalInventory = null;
        this.fields_physicalInventory = null;
        this.selectedFields_dispose = null;
        this.fields_dispose = null;
        this.selectedFields_issue = null;
        this.fields_issue = null;
        this.selectedFields_pack = null;
        this.fields_pack = null;
        this.selectedFields_ship = null;
        this.fields_ship = null;
        this.selectedFields_return = null;
        this.fields_return = null;
    }

    private submit = () => {
        if (this._form.invalid) {
            this._invalidForm = true;
        } else {
            this._invalidForm = false;
            const model = this._form.value;

            model['isAsset'] = false;
            model['groupId'] = model.mobileAppGroup.id;
            model['name'] = model.mobileAppGroup.name;
            model['chooseReceive'] = (this.selectedFields_receive != null && this.fields_receive != null) ? true : false;
            model['chooseMove'] = (this.selectedFields_move != null && this.fields_move != null) ? true : false;
            model['choosePhysicalInventory'] = (this.selectedFields_physicalInventory != null && this.fields_physicalInventory != null) ? true : false;
            model['chooseDispose'] = (this.selectedFields_dispose != null && this.fields_dispose != null) ? true : false;
            model['chooseIssue'] = (this.selectedFields_issue != null && this.fields_issue != null) ? true : false;
            model['choosePack'] = (this.selectedFields_pack != null && this.fields_pack != null) ? true : false;
            model['chooseShip'] = (this.selectedFields_ship != null && this.fields_ship != null) ? true : false;
            model['chooseReturn'] = (this.selectedFields_return != null && this.fields_return != null) ? true : false;
            model['chooseRoute'] = false;
            model['chooseCheckout'] = false;
            model['chooseCheckin'] = false;
            model['chooseAssign'] = false;
            model['chooseReservation'] = false;
            model['choosePerformMaintenance'] = false;
            model['receiveSelectedFields'] = (this.selectedFields_receive != null && this.fields_receive != null) ? this.selectedFields_receive.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['moveSelectedFields'] = (this.selectedFields_move != null && this.fields_move != null) ? this.selectedFields_move.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['physicalInventorySelectedFields'] = (this.selectedFields_physicalInventory != null && this.fields_physicalInventory != null) ? this.selectedFields_physicalInventory.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['disposeSelectedFields'] = (this.selectedFields_dispose != null && this.fields_dispose != null) ? this.selectedFields_dispose.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['issueSelectedFields'] = (this.selectedFields_issue != null && this.fields_issue != null) ? this.selectedFields_issue.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['packSelectedFields'] = (this.selectedFields_pack != null && this.fields_pack != null) ? this.selectedFields_pack.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['shipSelectedFields'] = (this.selectedFields_ship != null && this.fields_ship != null) ? this.selectedFields_ship.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['returnSelectedFields'] = (this.selectedFields_return != null && this.fields_return != null) ? this.selectedFields_return.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['routeSelectedFields'] = "";
            model['checkoutSelectedFields'] = "";
            model['checkinSelectedFields'] = "";
            model['assignSelectedFields'] = "";
            model['reservationSelectedFields'] = "";
            model['performMaintenanceSelectedFields'] = "";
            model['receiveAvailableFields'] = (this.selectedFields_receive != null && this.fields_receive != null) ? this.fields_receive.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['moveAvailableFields'] = (this.selectedFields_move != null && this.fields_move != null) ? this.fields_move.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['physicalInventoryAvailableFields'] = (this.selectedFields_physicalInventory != null && this.fields_physicalInventory != null) ? this.fields_physicalInventory.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['disposeAvailableFields'] = (this.selectedFields_dispose != null && this.fields_dispose != null) ? this.fields_dispose.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['issueAvailableFields'] = (this.selectedFields_issue != null && this.fields_issue != null) ? this.fields_issue.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['packAvailableFields'] = (this.selectedFields_pack != null && this.fields_pack != null) ? this.fields_pack.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['shipAvailableFields'] = (this.selectedFields_ship != null && this.fields_ship != null) ? this.fields_ship.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['returnAvailableFields'] = (this.selectedFields_return != null && this.fields_return != null) ? this.fields_return.filter((i: any) => i.title != "").map((x: { [x: string]: any; }) => x["title"]).join(",") : "";
            model['routeAvailableFields'] = "";
            model['checkoutAvailableFields'] = "";
            model['checkinAvailableFields'] = "";
            model['assignAvailableFields'] = "";
            model['reservationAvailableFields'] = "";
            model['performMaintenanceAvailableFields'] = "";
            if (!this._isNew) {
                this._buildYourAppsService
                    .updateBuildYourApp(this._model.id, model)
                    
                    .subscribe(() => {
                        this._closeForm();
                    });
            } else {
                this._buildYourAppsService
                    .createBuildYourApp(model)
                    
                    .subscribe((response: any) => {
                        if (response != null && response['message'] != null) {
                            this._layoutComponent.openPopup({
                                title: 'Alert',
                                message: response['message'],
                                withoutConfirm: true
                            });
                            if (response['close'] != null) {
                                if (response['close'] == true) {
                                    this._closeForm();
                                } else {
                                    return;
                                }
                            }
                        }
                        this._closeForm();
                    });
            }
        }
    }
}
